export var ConstantValue;
(function (ConstantValue) {
    ConstantValue["EVERY"] = "*";
    ConstantValue["NONE"] = "?";
    ConstantValue["LAST_DAY_WEEK"] = "LW";
    ConstantValue["LAST_DAY"] = "L";
})(ConstantValue || (ConstantValue = {}));
